<template>
  <div v-bind:class="{ invalid:!valid} + ' col-lg-4' + ' col-md-6'">
    <div class=" relative hover-card">
      <div @click="productDetails" v-bind:style="'background-image: url(' + thumbnailSrc + ')'"
        class="product-card-image"></div>
      <div class="grey-backing-card">
        <h3 class="card-title" @click="productDetails">{{productTitle}}</h3>
        <p v-if="product.type=='engine'">Engine Type: {{product.metadata.engine_type}}</p>
        <p><strong>{{priceString}}</strong></p>
        <p style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;opacity:.6">
          {{productDescription}}</p>
        <div v-if="!inCart" @click="addToCart" class="button-container space-top-small">
          <div class="standard-button d-flex flex-row">
            <div class="cart-left d-flex align-items-center">
              <p>Add to Cart</p>
            </div>
            <div class="cart-right d-flex align-items-center justify-content-center">
              <CartIcon :size="100" fillColor="rgb(255,255,255)" />
            </div>
          </div>
        </div>
        <div v-else @click="removeFromCart" class="button-container space-top-small">
          <div class="standard-button d-flex flex-row">
            <div class="cart-left d-flex align-items-center">
              <p>Remove from Cart</p>
            </div>
            <div class="cart-right d-flex align-items-center justify-content-center">
              <MinusIcon :size="100" fillColor="rgb(255,255,255)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CartIcon from 'vue-material-design-icons/Cart.vue';
  import MinusIcon from 'vue-material-design-icons/Minus.vue';
  export default {
    props: {
      valid: {
        type: Boolean,
        default: true,
      },
      product: {
        type: Object,
        default: function () {
          return {
            id: "",
            type: "Product Type",
            metadata: {},
            title: "Product Title",
            price: 5.0,
            description: "Product Description",
            status: "listed",
            media: [],
          };
        },
      },
    },
    computed: {
      productTitle() {
        if (this.valid) {
          return this.product.title;
        }
        return this.product.title + " - Invalid Item"
      },
      productDescription() {
        if (this.valid) {
          return this.product.description;
        }
        return "Item is invalid, it may have already been sold. Please remove it from your cart to continue.";
      },
      priceString() {
        return this.product.price.toLocaleString(undefined, {
          style: 'currency',
          currency: "USD",
        });
      },
      thumbnailSrc() {
        var id = "";
        if (typeof this.product.metadata.thumbnail != "undefined") {
          id = this.product.metadata.thumbnail;
        } else if (this.media.length != 0) {
          id = this.media[0].id;
        }
        return process.env.VUE_APP_API_URL + `/media/thumbnails/300/${id}.png`;
      },
      thumbnailOriginal() {
        var id = "";
        if (typeof this.product.metadata.thumbnail != "undefined") {
          id = this.product.metadata.thumbnail;
        } else if (this.media.length != 0) {
          id = this.media[0].id;
        }
        return process.env.VUE_APP_API_URL + `/media/${id}.png`;
      },
      src(id) {
        return process.env.VUE_APP_API_URL + `/media/${id}.png`;
      },
      inCart() {
        return this.product.id in this.$store.state.cart;
      },
    },
    methods: {
      addToCart() {
        this.$store.dispatch("addToCart", this.product);
      },
      removeFromCart() {
        this.$store.dispatch("removeFromCart", this.product.id);
      },
      productDetails() {
        this.$router.push(`/products/details/${this.product.id}`);
      }
    },
    components: {
      CartIcon,
      MinusIcon
    }
  };
</script>

<style scoped>
  .invalid {
    background-color: red;
  }
</style>